// extracted by css-extract-rspack-plugin
export default {"searchMatchText":"SearchMatchText-module__searchMatchText__n6aQc","g-emoji":"SearchMatchText-module__g-emoji__Z42qP","truncatedName":"SearchMatchText-module__truncatedName__X6PYS"};